import { ActionType } from "../../../../UI.Controls/Actions/IAction";
import { ILogicalComponent } from "../../../LogicalTree/ILogicalComponent";
import { StandardAction } from "../Actions/StandardAction";
import { IMultiRecordsComponent } from "./FrameInterfaces";
import { IListFrameForOverrides, ListFrameRightsEvaluationOverrides } from "./ListFrameRightsEvaluationOverrides";

export class TwoListFrameRightsEvaluationOverrides extends ListFrameRightsEvaluationOverrides {
    protected override readonly __frame: ITwoListFrameForOverrides;

    protected override get _frame(): ITwoListFrameForOverrides {
        return this.__frame;
    }

    protected override async _standardActionsEnabled(controlWrapper: ILogicalComponent): Promise<boolean | null> {
        const superResult = super._standardActionsEnabled(controlWrapper);
        this._debugPrintMethod(`[TwoListFrameRightsEvaluationOverrides] Executing right override function for enabled right for StandardAction. OwnerFrame enabled is "${this._frame.enabled}".`, 10); // ` TODO-rites: remove !!

        const standardAction = controlWrapper.control as StandardAction;

        if (standardAction) {
            switch (standardAction.actionType) {
                case ActionType.standardMoveRightRecords:
                    return (this._frame instanceof IMultiRecordsComponent && this._frame.isMultiSelectingMode && this._frame.canInsert);
                case ActionType.standardMoveLeftRecords:
                    return (this._frame instanceof IMultiRecordsComponent && this._frame.isMultiSelectingMode && this._frame.canDelete);
                case ActionType.standardMoveRightRecord:
                    return this._frame.canInsert && this._frame.canValueLoad;
                case ActionType.standardMoveLeftRecord:
                    return this._frame.canDelete && this._frame.canValueLoad;
            }
        }

        return superResult;
    }

    protected override async _standardActionsVisible(controlWrapper: ILogicalComponent): Promise<boolean | null> {
        this._debugPrintMethod(`[TwoListFrameRightsEvaluationOverrides] Executing right override function for visible right for StandardAction. OwnerFrame enabled is "${this._frame.enabled}".`, 10); // ` TODO-rites: remove !!

        const standardAction = controlWrapper.control as StandardAction;

        if (standardAction) {
            switch (standardAction.actionType) {
                case ActionType.standardMoveRightRecords:
                case ActionType.standardMoveLeftRecords:
                    return (this._frame instanceof IMultiRecordsComponent && this._frame.isMultiSelectingMode);
                case ActionType.standardEditRecord:
                case ActionType.standardEditRecords:
                    return this._frame.isEditable;
            }
        }

        return await super._standardActionsVisible(controlWrapper);
    }
}

interface ITwoListFrameForOverrides extends IListFrameForOverrides {
    canValueLoad: boolean;
}
